import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const state = {
  isObserverInTrain: {},
  observerPos: {},
  oppositeObjPos: {},
  sceneShift: {},
  lightsEnabled: {}
}

const mutations = {
  changeIsObserverInTrain (state, payload) {
    Vue.set(state.isObserverInTrain, payload['sceneId'], payload['value'])
  },
  changeObserverPos (state, payload) {
    Vue.set(state.observerPos, payload['sceneId'], payload['value'])
  },
  changeOppositeObjPos (state, payload) {
    Vue.set(state.oppositeObjPos, payload['sceneId'], payload['value'])
  },
  changeSceneShift (state, payload) {
    Vue.set(state.sceneShift, payload['sceneId'], payload['value'])
  },
  changeLightsEnabled (state, payload) {
    Vue.set(state.lightsEnabled, payload['sceneId'], payload['value'])
  }
}

export default new Vuex.Store({
  state: state,
  mutations: mutations
})
